(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminPostsManualAdd', {
                    requireLogin: true,
                    url: 'admin/manualPosts',
                    templateUrl: 'app/admin/manualPosts/manualPosts.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'manualPosts']
                    },
                    controller: 'manualPostsCtrl'
                })
                .state('home.adminFindPost', {
                    requireLogin: true,
                    url: 'admin/findPost',
                    templateUrl: 'app/admin/manualPosts/findPost/findPost.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'findPost']
                    },
                    controller: 'findPostCtrl',
                    controllerAs: 'vm'
                })
        }]);
})();